/*
 * Comments on usage from Ryan Tsao:
 * 
$( "#network_threshold .sliderBar" ).axSlider({
   //default value (index)
   value: 4,
   //the width of slider
   width: 400,
   unlimited: false,
   valuesMap: {
       60: "1 hour",
       120: "2 hours",
       240: "4 hours",
       480: "8 hours",
       720: "12 hours",
       1440: "1 day",
       2880: "2 days",
       4320: "3 days",
       10080: "7 days",
       20160: "14 days"
   }
});

 */
(function ($, undefined) {

    $.widget("ui.axSlider", $.ui.slider, {

        options: {
            width: 400,
            step: 1,
        },

        _create: function () {
            //Array of the keys
            this.valuesArray = Object.keys(this.options.valuesMap);
            if (this.options.unlimited) {
                this.valuesArray.push(0);
            }

            //Set the max to the # of values
            this.options.max = Object.keys(this.options.valuesMap).length - 1;

            //Save the initial value as the default value -> needed for styling tick marks
            this.defaultVal = this.options.value;
            this.sliderDisplay = $('<div></div>').appendTo(this.element).addClass("sliderDisplay");
            this.sliderInput = $('<input type="hidden">').appendTo(this.element);

            $.ui.slider.prototype._create.apply(this);

            //Set correct width
            this.element.css('width', this.options.width);


            //Generate tick marks
            this.options.tickLabelsCount = Object.keys(this.options.valuesMap).length - 1;
            this.element.addClass("ui-slider-" + this.orientation + "-ticks-labels");

            if (this.options.unlimited) {
                this.options.max++;
                this.options.tickLabelsCount++;
                this.options.valuesMap[0] = "Unlimited";

            }

            this.tickLabels = [];
            var ticksLabelsContainer = $("<div></div>").appendTo(this.element).addClass("ticks-labels");
            for (var i = 0; i <= this.options.tickLabelsCount; i++) {

                //We only want tick marks to show at the initial, default, and final values
                var simpleTick = (i != 0 && i != this.options.tickLabelsCount && i != this.defaultVal) ? true : false;
                if (simpleTick) {
                    this.tickLabels[i] = $('<div class="simpleTick"></div>').appendTo(ticksLabelsContainer).addClass("ticks-label");
                    this.tickLabels[i].css({
                        "left": (i * this.element.innerWidth() / this.options.tickLabelsCount) - this.tickLabels[i].width() / 2 + this.tickLabels[i].width() / 2,
                        "borderLeft": "2px solid #c6c6c6",
                        "height": 10,
                        "width": 10
                    });

                } else {
                    this.tickLabels[i] = $("<div>" + this.options.valuesMap[this.valuesArray[i]] + "</div>").appendTo(ticksLabelsContainer).addClass("ticks-label");
                    this.tickLabels[i].css({
                        "left": (i * this.element.innerWidth() / this.options.tickLabelsCount) - this.tickLabels[i].width() / 2
                    });
                    //Make default tick black
                    if (i == this.defaultVal) {
                        this.tickLabels[i].css({
                            'color': '#000'
                        });
                    }
                }
            }




            this._refreshValue();
        },
        _refreshValue: function () {
            $.ui.slider.prototype._refreshValue.apply(this);

            //Update the display and the input to new value
            var currentVal = this.valuesArray[this.options.value];
            var displayVal = this.options.valuesMap[currentVal];
            this.sliderDisplay.html(displayVal);
            this.sliderInput.val(currentVal);
        }
    });

    $.extend($.ui.axSlider, {
        version: "1.0.0"
    });

}(jQuery));